<form class="search--bar form" [formGroup]="searchForm" role="search">
  <div class="search--bar__icon">
    <i class="icon icon--dark icon-ui-search"></i>
  </div>
  <input
    id="search-query"
    class="search--bar__input"
    type="text"
    name="query"
    formControlName="query"
    autocomplete="off"
    [disabled]="searchDisabled"
    [placeholder]="placeholder ?? 'general.search.label' | translate"
    [attr.aria-label]="placeholder ?? 'general.search.label' | translate"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput()"
    (keydown)="onKeyDown($event)"
  />
  @if (hasInput) {
    <button
      type="reset"
      class="search--bar__cancel"
      (mousedown)="$event.preventDefault()"
      (click)="onCancel(true)"
      [attr.aria-label]="'general.label.close' | translate"
    >
      <i class="icon icon-ui-close--sm"></i>
    </button>
  }
</form>
@if (!static) {
  <button
    type="button"
    class="search--bar__close d--none d--block--sm"
    (click)="onClose(userEventAction.close)"
    [attr.aria-label]="'general.label.close' | translate"
  >
    <i class="icon icon-ui-close--sm"></i>
  </button>
}
